import { fetchEndpoint } from "../network";

/**
 * 角色管理
 */

export default {
  // 媒体号统计
  topStat(params) {
    return fetchEndpoint(
      "/chart/get_media_account_top_state_overview",
      "GET",
      params
    );
  },

  // 列表
  likeStat(params) {
    return fetchEndpoint(
      "/chart/get_content_like_state_overview",
      "GET",
      params
    );
  },

  // 列表
  followStat(params) {
    return fetchEndpoint(
      "/chart/get_media_followers_state_overview",
      "GET",
      params
    );
  },

  //关注数
  followList(params) {
    return fetchEndpoint("/chart/top/follow", "GET", params);
  },
  //内容数
  contentList(params) {
    return fetchEndpoint("/chart/top/content", "GET", params);
  },
  //收藏数
  collectionList(params) {
    return fetchEndpoint("/chart/top/collection", "GET", params);
  },
  //阅读数
  viewList(params) {
    return fetchEndpoint("/chart/top/view", "GET", params);
  },
  //帖子数
  postList(params) {
    return fetchEndpoint("/chart/top/post", "GET", params);
  },

  //创作平台专用
  contentViewNum(params) {
    return fetchEndpoint("/chart/media/content/overview", "GET", params);
  },
};
